







































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'
import { Referral } from '@/api/model/referral'
import { ContactView } from '@/api/types'

@Component
export default class OrderColumnCustomer extends Vue {
    @Prop({ required: true }) order!: Order

    get routeToDetail() {
        return {
            name: 'orders_detail',
            params: {
                orderId: this.order.id,
                contactId: this.order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    get referral(): Referral {
        return this.order.referral
    }

    get contactView(): ContactView {
        return this.$currentCompany.defaultContactView
    }
}
